module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-3.a58dd0e3.svg";